module.exports = __webpack_public_path__ + "img/agent_people.8d56fe7b.png";